import AurUploadBox from '../common/aur-uploadbox/AurUploadBox';
import {ReactComponent as FileUpload} from '../../../src/assests/svg/upload-Icon.svg';
import {Box} from '@mui/material';
import AurPageHeader from '../common/aur-page-header/AurPageHeader';
import {useNavigate} from 'react-router-dom';
import {t} from 'i18next';
import BulkUserDownloadTemplate from './BulKUserDownloadTemplate';
import {useEffect, useState} from 'react';
import ClientSelectionModal from './ClientSelectionModal';
import {useDispatch, useSelector} from 'react-redux';
import {
  openClientsDialog,
  closeClientsDialog,
} from '../../redux/slices/reportsDialogSlice';
import {RootState} from '../../redux/store';
import {setSelectedClient} from '../../redux/slices/bulkUserFileNameSlice';
import {
  SelectedClientState,
  setBulkUploadClientId,
} from '../../redux/slices/selectedClientSlice';
import AurLoadingIndicator from '../common/aur-loading-indicator/AurLoadingIndictor';
import {getClientsList} from '../../api/UserManagementService';
import {CLIENT_SEARCH_ENABLE_COUNT} from '../layouts/AurClientDropDownWrapper';
/**
 * Defined the BulkUserUploadScreen component
 * it will displays the bulk user upload screen.
 * AurPageHeader - for the common header
 */

export interface IClientSelected {
  clientId: string;
  name: string;
  projects?: {projectId: string; projectName: string}[];
}
export const BulkUserUploadScreen = () => {
  const clientId = useSelector(
    (state: RootState) => state.selectedClient
  ).bulkUploadClientId;

  const selectedClientName = useSelector(
    (state: RootState) => state.bulkUserFile.selectedClient
  );

  const duplicateEmail = useSelector(
    (state: RootState) => state.bulkUserFile.duplicateEmail
  );

  const [userClients, setUserClients] = useState<IClientSelected[]>([]);
  const [clientSearchEnable, setClientSearchEnable] = useState<boolean>(false);
  const [isGetClientsAsLookupLoading, setIsGetClientsAsLookupLoading] =
    useState(false);
  const searchTerm = useSelector(
    (state: RootState) => state.bulkUserFile.searchTerm
  );
  const navigate = useNavigate();
  const backNavigation = () => {
    navigate('/users');
  };
  const dispatch = useDispatch();

  const fetchClientList = async (searchInput?: string) => {
    try {
      setIsGetClientsAsLookupLoading(true);
      let queryParam = 'pageSize=25&pageNumber=1';
      if (searchTerm) queryParam += `&SearchTerm=${searchTerm}`;
      const result = await getClientsList(queryParam);

      if (result.data.data.length !== 0) {
        const formatData = result.data.data.map((ele: any) => {
          return {clientId: ele.clientId, name: ele.name};
        });
        if (searchTerm === '' && formatData.length === 1) {
          dispatch(setSelectedClient(formatData?.[0]?.name));
          dispatch(setBulkUploadClientId(formatData?.[0]?.clientId));
          dispatch(closeClientsDialog());
        } else {
          dispatch(openClientsDialog());

          if (
            userClients.length === 0 &&
            formatData.length >= CLIENT_SEARCH_ENABLE_COUNT &&
            !clientSearchEnable
          ) {
            setClientSearchEnable(true);
          }
          const data: any = formatData.slice(0, CLIENT_SEARCH_ENABLE_COUNT);
          if (!searchInput) {
            const selectedOptionExitIndex = data.findIndex(
              (item: SelectedClientState) => item.clientId === clientId
            );
            if (selectedOptionExitIndex === -1 && clientId !== '') {
              const unformate = {clientId: clientId, name: selectedClientName};
              data.unshift(unformate);
              if (data.length >= CLIENT_SEARCH_ENABLE_COUNT)
                data.pop();
            }
          }
          setUserClients(data);
        }
      } else if (searchTerm === '' && result.data.data.length <= 0) {
        setUserClients([]);
        dispatch(closeClientsDialog());
      }
    } catch (e) {
      console.log('message', e);
    } finally {
      setIsGetClientsAsLookupLoading(false);
    }
  };

  useEffect(() => {
    fetchClientList();
  }, []);

  useEffect(() => {
    fetchClientList();
  }, [searchTerm]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch(setSelectedClient(''));
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [dispatch]);
  return (
    <>
      <Box className="bulkUpload-bg-Color">
        <div className="custom-header">
          {!duplicateEmail && (
            <ClientSelectionModal firstDropDownData={userClients} />
          )}
          <AurPageHeader
            heading={t('common.aurUploadBox.addTeamMemberText')}
            onLinkCLick={backNavigation}
            linkLabel={t('common.aurUploadBox.manageTeamMembers')}
            selectedClientName={selectedClientName}
            path="/users"
          />
        </div>
        <div className="upload-mainContainer ">
          <AurUploadBox
            title={t('common.aurUploadBox.title')}
            note={t('common.aurUploadBox.note')}
            description={t('common.aurUploadBox.description')}
            supportText={t('common.aurUploadBox.support')}
            FileUploadIcon={FileUpload}
            buttonLabel={t('common.aurUploadBox.chooseFile')}
            dragAndDropText={t('common.aurUploadBox.dragDropText')}
            isDragDrop={true}
            orText={true}
            borderClass={'gradient-border'}
            errorStateBorderClass={'error-state-border'}
            buttonHint={t('common.aurUploadBox.chooseButtonHint')}
            dataTestId="uploadBtn-test"
            descriptionClass="upload-description"
          />
        </div>
        <BulkUserDownloadTemplate />
      </Box>
      {
        <AurLoadingIndicator
          overlay={true}
          isOpen={isGetClientsAsLookupLoading}
        />
      }
    </>
  );
};

export default BulkUserUploadScreen;
